/**
 * Ranks negative feedback comments by normalized phrase frequency.
 */
export class BotReportedIssuesAggregator {
  /**
   * @param {Array<{ comment?: string }>} comments
   * @returns {Array<{ phrase: string, count: number }>}
   */
  aggregate(comments) {
    const counts = new Map();
    for (const row of Array.isArray(comments) ? comments : []) {
      const phrase = this._normalize(row?.comment);
      if (!phrase) continue;
      counts.set(phrase, (counts.get(phrase) || 0) + 1);
    }
    return [...counts.entries()]
      .map(([phrase, count]) => ({ phrase, count }))
      .sort((a, b) => b.count - a.count || a.phrase.localeCompare(b.phrase));
  }

  /**
   * @param {unknown} comment
   * @returns {string}
   */
  _normalize(comment) {
    return String(comment || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }
}
